/* eslint-disable indent */
import { html, LitElement } from 'lit';
import { customElement, query, state } from 'lit/decorators.js';
import { translate } from '../../helpers/translate.js';
import '../shared/sdb-dialog.js';
import './sdb-microlearning-select.js';
@customElement('sdb-microlearning-select-dialog')
class SdbMicrolearningSelectDialog extends LitElement {

    @state()
    accessor selectedValue = null;

    @state()
    accessor opened = false;

    @query('#select_ml_dialog')
    accessor selectDialog;

    constructor() {
        super();
        this.sender = null;
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('openMicrolearningSelectDialog', this._openDialog.bind(this));
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('openMicrolearningSelectDialog', this._openDialog.bind(this))
    }


    render() {
        return html`
            <sdb-dialog
                type="form"
                id="select_ml_dialog"
                heading=${translate('chooseMicrolearning')}
                ?opened=${this.opened}
                confirmCaption=${translate('select')}
                ?confirmDisabled=${this.selectedValue === null}
                @confirm=${() => { this._confirm(); }}
                @cancel=${() => { this._reset(); }}
                .bodyRenderer=${() => html`
                    <sdb-microlearning-select
                        .value=${this.selectedValue}
                        @selected=${(e) => { this._onSelected(e); }}>
                    </sdb-microlearning-select>
                `}>
            </sdb-dialog>
        `;
    }

    _openDialog(e) {
        this.sender = e.detail.sender;
        this.selectDialog.open();
    }

    _confirm() {
        this.dispatchEvent(new CustomEvent('elearningSelected', {
            detail: {
                elearning: this.selectedValue,
                sender: this.sender,
            },
            composed: true,
            bubbles: true,
        }));

        this._reset();
    }

    _onSelected(e) {
        this.selectedValue = e.detail.value;
    }

    _reset() {
        this.selectedValue = null;
    }
}

